<mat-dialog-content class="pick-detail-editor-dialog">
    <table>
        <tbody>
            <tr>
                <td>Open Order Qty ({{item.BaseUOM}}):</td>
                <td>{{openOrderQty}}</td>
            </tr>

            <tr>
                <td><label>{{item.isRolledGood ? "Piece Length" : "Pick Qty"}}:</label></td>
                <td>
                    <mat-form-field class="qty-field" floatLabel="never">
                        <input matInput inputmode='quantity' [(ngModel)]="allocation.Qty" placeholder="Qty" />
                    </mat-form-field>
                </td>
            </tr>

            <tr *ngIf="detail.OpenQty < 0">
                <td>Excess Pick Qty:</td>
                <td>{{excessPickQty}}</td>
            </tr>
        </tbody>

        <!-- Allowances -->
        <tbody *ngIf="canHaveAllowances">
            <!-- End of Roll -->
            <tr>
                <td>
                    <mat-slide-toggle [(ngModel)]="allocation.EOR" (change)="onSliderChange('EOR', EORQty)">
                        End of {{item.isRolledGood ? 'Roll' : 'Stock'}}
                    </mat-slide-toggle>
                </td>
                <td [style.display]="allocation.EOR ? 'table-cell' : 'none'">
                    <mat-form-field class="qty-field" floatLabel="never">
                        <input #EORQty matInput inputmode='quantity' [(ngModel)]="allocation.EORQty"
                            placeholder="Qty" />
                    </mat-form-field>
                </td>
            </tr>

            <!-- Pieces -->
            <tr [style.display]="item.isRolledGood ? 'table-row' : 'none'">
                <td>
                    <mat-slide-toggle [(ngModel)]="allocation.PCS"
                        (change)="onSliderChange('PCS', PCSQty)">Pieces</mat-slide-toggle>
                </td>
                <td [style.display]="allocation.PCS ? 'table-cell' : 'none'">
                    <mat-form-field class="qty-field" floatLabel="never">
                        <input #PCSQty matInput inputmode='quantity' [(ngModel)]="allocation.PCSQty"
                            placeholder="Qty" />
                    </mat-form-field>
                </td>
            </tr>

            <!-- Material Flaw -->
            <tr [style.display]="item.isRolledGood ? 'table-row' : 'none'">
                <td>
                    <mat-slide-toggle [(ngModel)]="allocation.FLA"
                        (change)="onSliderChange('FLA', FLAQty)">Flaw</mat-slide-toggle>
                </td>
                <td [style.display]="allocation.FLA ? 'table-cell' : 'none'">
                    <mat-form-field class="qty-field" floatLabel="never">
                        <input #FLAQty matInput inputmode='quantity' [(ngModel)]="allocation.FLAQty"
                            placeholder="Qty" />
                    </mat-form-field>
                </td>
            </tr>

            <!-- <tr [style.display]="item.isRolledGood && FLASlider.checked ? 'table-row' : 'none'">
                    <td colspan="2">
                        <mat-expansion-panel hideToggle color="primary">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <camera-capture #image (onChange)="captureFlawImage($event)">
                                    </camera-capture>
                                </mat-panel-title>
                                <mat-panel-description>
                                    <span *ngIf="editAllocation!.FLAImgs.length == 0">Photograph Flaw</span>
                                    <span *ngIf="editAllocation!.FLAImgs.length > 0">Photos
                                        ({{editAllocation!.FLAImgs.length}})</span>
                                </mat-panel-description>
                            </mat-expansion-panel-header>
                            <div *ngFor="let image of editAllocation!.FLAImgs; let i = index" class="flaw-image">
                                <div>
                                    <span
                                        style="display:inline-block; max-width:140px; overflow:hidden; text-overflow:ellipsis;">{{image.file.name}}</span>
                                    <button (click)="deleteFlawImage(i)" style="float:right;">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </div><br />
                                <img [src]="image.src" style="max-width: 200px;" />
                            </div>
                        </mat-expansion-panel>
                    </td>
                </tr> -->
        </tbody>

        <tbody>
            <!-- Full Rolls -->
            <tr [style.display]="canShipFullRoll ? 'table-row' : 'none'">
                <td>
                    <mat-slide-toggle [(ngModel)]="detail.ShipFullRolls" #FULSlider
                        (change)="onSliderChange('FUL')">Full Roll
                    </mat-slide-toggle>
                </td>
            </tr>

            <!-- Stock Adjustment -->
            <tr>
                <td colspan="3">
                    <hr />
                </td>
            </tr>

            <tr>
                <td colspan="2">
                    <inventory-adjustment-editor #pickAdjustmentQtyEditor [inventory]="source"
                        [OnHandLabel]="source.stockItem.isLotSerItem ? 'Roll Balance' : 'On Hand'"
                        [required]="source.rolloutRequired"></inventory-adjustment-editor>
                </td>
            </tr>
        </tbody>
    </table>
</mat-dialog-content>
<mat-dialog-actions style="justify-content:space-between;">
    <button mat-raised-button color="accent" type="button" (click)="onDeleteAllocationButtonClick()">
        <mat-icon>delete</mat-icon>
    </button>

    <button matSuffix mat-raised-button color="primary" (click)="onOKButtonClick()" tabindex="-1" type="submit"
        style="justify-content: flex-end;" [disabled]="!currentAllocationAcceptable">OK</button>
</mat-dialog-actions>